/*
 * @descripttion: 基础路由
 * @Author: echo
 * @Date: 2022-03-23 17:12:12
 * @LastEditors: echo
 * @LastEditTime: 2022-04-12 01:52:30
 * @autograph: 任何一个傻子都能写出让电脑能懂的代码，而只有好的程序员可以写出让人能看懂的代码
 */
import type { App } from 'vue'
import { message } from 'ant-design-vue'
import { createRouter, createWebHistory } from 'vue-router'
import { isDev } from '@/utils'
import { LOGIN_ROUTE_NAME, NO_REDIRECT_PATHS, UNRESET_ROUTES } from './constant'
import createGuard from './guard'
import baseRoutes from './routes/base'

export const router = createRouter({
  history: createWebHistory(),
  routes: baseRoutes,
  strict: true,
  scrollBehavior: () => ({ left: 0, top: 0 })
})

let lock = false
// 错误监听
router.onError((error: Error) => {
  if (!lock) {
    lock = true

    // 显示错误信息
    message.error(`页面存在错误：${error.message}`)
    console.error(error)

    // 如果是动态加载模块失败的错误，且非开发环境，则刷新页面
    if (error.message?.includes('Failed to fetch dynamically imported module')) {
      if (!isDev) {
        window.location.reload()
      }
    }

    // 短暂延迟后解锁，允许后续错误处理
    setTimeout(() => {
      lock = false
    }, 0)
  }
})

/**
 * reset router
 */
export function resetRouter() {
  router.getRoutes().forEach(route => {
    const { name } = route
    if (name && !UNRESET_ROUTES.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

// config router
export function setupRouter(app: App<Element>) {
  app.use(router)
}

/**
 * config router guard
 */
export function setupRouterGuard() {
  createGuard(router)
}

/**
 * 获取登录路由，自动清理嵌套 redirect
 */
export function resloveToLoginPath(redirect?: unknown) {
  const isExcluded = (p: string) => redirect === p || (redirect as string).toLowerCase().startsWith(p.toLowerCase())
  const shouldSkip = typeof redirect !== 'string' || NO_REDIRECT_PATHS.some(isExcluded)

  if (shouldSkip) return { name: LOGIN_ROUTE_NAME }

  // 移除已有 redirect 参数，防止嵌套
  const clean = redirect.replace(/([?&])redirect=[^&]*/g, '').replace(/\?$|&$/, '')
  return { name: LOGIN_ROUTE_NAME, query: clean ? { redirect: clean } : {} }
}
